<span class="yc-tag" [class]="tagColorClassMap[tag.color]">
  <yc-button *ngIf="showLeadingIcon" 
    [icon]="true"
    [tooltipText]="tagMarkedForRemoval ?
      ('tags:textTagWillBeRemoved' | ycI18n: 'Tag will be removed') :
      tag.enabled ?
        ('tags:textTagIsActive' | ycI18n: 'Tag is active') :
        ('tags:textTagIsInactive' | ycI18n: 'Tag is inactive')">
    <yc-fa
      [icon]="tagMarkedForRemoval ?
        'times' :
        tag.enabled ?
          'check' :
          'ban'"
      [light]="true">
    </yc-fa>
  </yc-button>

  {{ tag.name }}

  <div *ngIf="!readonly"
    class="btn-group" 
    dropdown container="body">
    <yc-button dropdownToggle 
      [icon]="true"
      [fontAwesomeIcon]="'cog'"
      [value]="'GLOBAL:textSettings' | ycI18n: 'Settings'">
    </yc-button>

    <ul *dropdownMenu
      class="dropdown-menu dropdown-right"
      role="menu">
      <li *ngIf="tag.enabled"
        role="menuitem"
        class="dropdown-item with-icon-description ps-3"
        [ycTrackClick]="'Disable tag'"
        (click)="onTagMark.emit('Disable')">
        <yc-fa 
          icon="ban"
          [light]="true" 
          class="text-link me-3">
        </yc-fa>
        <span>
          <yc-i18n
            key="tags:btnMarkTagAsInactive"
            defaultValue="Mark tag as inactive">
          </yc-i18n>
          <br />
          <small>
            <yc-i18n
              key="tags:btnMarkTagAsInactiveDescription"
              defaultValue="This tag will move to inactive. It will not be removed from areas that currently use this tag.">
            </yc-i18n>
          </small>
        </span>
      </li>
      <li *ngIf="!tag.enabled"
        role="menuitem"
        class="dropdown-item with-icon-description ps-3"
        [ycTrackClick]="'Enable tag'"
        (click)="onTagMark.emit('Enable')">
        <yc-fa icon="check-circle" 
          [light]="true"
          class="me-3 text-success">
        </yc-fa>
        <span>
          <yc-i18n
            key="tags:btnMarkTagAsActive"
            defaultValue="Mark tag as active">
          </yc-i18n>
          <br />
          <small>
            <yc-i18n
              key="tags:btnMarkTagAsActiveDescription"
              defaultValue="This tag will move to active.">
            </yc-i18n>
          </small>
        </span>
      </li>
      <li *ngIf="!tagMarkedForRemoval"
        role="menuitem"
        class="dropdown-item with-icon-description ps-3"
        [ycTrackClick]="'Delete tag'"
        (click)="onTagMark.emit('delete')">
        <yc-fa icon="times" 
          [light]="true"
          class="text-danger me-3">
        </yc-fa>
        <span>
          <yc-i18n
            key="tags:btnDeleteInstancesOfTag"
            defaultValue="Delete all instances of this tag">
          </yc-i18n>
          <br />
          <small>
            <yc-i18n
              key="tags:btnDeleteInstancesOfTagDescription"
              defaultValue="This tag will no longer appear in the portal. It will be removed from areas that currently use this tag.">
            </yc-i18n>
          </small>
        </span>
      </li>
      <li *ngIf="allowColorChange">
        <gc-tag-color-picker
          [color]="tag.color"
          (colorChange)="onTagColorChange.emit($event)">
        </gc-tag-color-picker>
      </li>
    </ul>
  </div>
</span>
